if (!window.__bc_listicle_inited) {
window.__bc_listicle_inited = true;
/* ===== block lines 423-472 ===== */
  document.addEventListener('DOMContentLoaded', function() {
    var faqDetails = document.querySelectorAll('.v2-faq details');
    faqDetails.forEach(function(d) {
      d.setAttribute('open', '');
      var body = d.querySelector(':scope > div');
      if (!body) return;
      body.style.height = '0px';
    });
    function close(d) {
      var body = d.querySelector(':scope > div');
      if (!body) return;
      var h = body.scrollHeight;
      body.style.height = h + 'px';
      void body.offsetHeight;
      d.classList.remove('is-open');
      body.style.height = '0px';
    }
    function open(d) {
      var body = d.querySelector(':scope > div');
      if (!body) return;
      d.classList.add('is-open');
      var target = body.scrollHeight;
      body.style.height = target + 'px';
      var onEnd = function(e) {
        if (e.propertyName !== 'height') return;
        if (d.classList.contains('is-open')) body.style.height = 'auto';
        body.removeEventListener('transitionend', onEnd);
      };
      body.addEventListener('transitionend', onEnd);
    }
    faqDetails.forEach(function(d) {
      var summary = d.querySelector(':scope > summary');
      if (!summary) return;
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        var isOpen = d.classList.contains('is-open');
        faqDetails.forEach(function(other) {
          if (other !== d && other.classList.contains('is-open')) {
            var ob = other.querySelector(':scope > div');
            if (ob && ob.style.height === 'auto') {
              ob.style.height = ob.scrollHeight + 'px';
              void ob.offsetHeight;
            }
            close(other);
          }
        });
        if (isOpen) close(d); else open(d);
      });
    });
  });

/* ===== block lines 679-816 ===== */
  document.addEventListener('DOMContentLoaded', function(){
    var cards = document.querySelectorAll('.v3-morph');

    // Pre-measure full content height for each card AVEC l'état open appliqué (paddings, margins, etc.)
    // pour que la mesure reflète exactement ce qu'on aura à l'ouverture. Sync donc pas de flash visible.
    cards.forEach(function(card){
      var text = card.querySelector('.v3-morph-text');
      var body = card.querySelector('.v3-morph-body');
      if (!text || !body) return;
      var savedMH = body.style.maxHeight;
      var savedOp = body.style.opacity;
      var savedTr = body.style.transition;
      var wasOpen = card.dataset.open;
      // Force state open + expand body
      card.dataset.open = 'true';
      body.style.transition = 'none';
      body.style.maxHeight = 'none';
      body.style.opacity = '1';
      // Force reflow then measure
      var h = text.scrollHeight;
      card._fullContentHeight = h + 20; // +20px buffer pour les marges entre états
      // Restore
      card.dataset.open = wasOpen || 'false';
      body.style.maxHeight = savedMH;
      body.style.opacity = savedOp;
      body.style.transition = savedTr;
    });

    // Init : .is-solution toujours open
    document.querySelectorAll('.v3-morph.is-solution').forEach(function(card){
      card.dataset.open = 'true';
      var btn = card.querySelector('.v3-morph-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      adjustMobileHeight(card);
    });

    function adjustMobileHeight(card) {
      var toggle = card.querySelector('.v3-morph-toggle');
      if (!toggle) return;
      if (window.innerWidth >= 720 || card.dataset.open !== 'true') {
        toggle.style.minHeight = '';
        return;
      }
      var textH = card._fullContentHeight || (card.querySelector('.v3-morph-text') || {}).scrollHeight || 400;
      toggle.style.minHeight = (220 + textH) + 'px';
    }

    function openCard(card) {
      cards.forEach(function(c){
        if (c.classList.contains('is-solution')) return;
        c.dataset.open = 'false';
        var b = c.querySelector('.v3-morph-toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
        // reset inline minHeight on close
        var t = c.querySelector('.v3-morph-toggle');
        if (t) t.style.minHeight = '';
      });
      card.dataset.open = 'true';
      var bb = card.querySelector('.v3-morph-toggle');
      if (bb) bb.setAttribute('aria-expanded', 'true');
      adjustMobileHeight(card);
    }

    // Recalc mobile height on resize for the currently-open card
    window.addEventListener('resize', function(){
      cards.forEach(function(c){
        if (c.dataset.open === 'true' || c.classList.contains('is-solution')) {
          adjustMobileHeight(c);
        } else {
          var t = c.querySelector('.v3-morph-toggle');
          if (t) t.style.minHeight = '';
        }
      });
    });

    // Sommaire (TOC) links : ouvrir la raison + scroll
    document.querySelectorAll('.v3-toc-item a').forEach(function(link){
      link.addEventListener('click', function(e){
        var href = link.getAttribute('href') || '';
        if (!href.startsWith('#raison-')) return;
        var target = document.getElementById(href.slice(1));
        if (!target || !target.classList.contains('v3-morph')) return;
        e.preventDefault();
        openCard(target);
        setTimeout(function(){
          var rect = target.getBoundingClientRect();
          window.scrollTo({
            top: window.pageYOffset + rect.top - 130,
            behavior: 'smooth'
          });
        }, 120);
      });
    });

    cards.forEach(function(card){
      var btn = card.querySelector('.v3-morph-toggle');
      if (!btn) return;
      btn.addEventListener('click', function(e){
        // ignore clicks on the solution CTA (let the link work)
        if (e.target.closest('.v3-morph-cta-solution')) return;
        // Card .is-solution : toujours ouverte, ignorer les clics toggle
        if (card.classList.contains('is-solution')) return;
        var wasOpen = card.dataset.open === 'true';
        // Close all SAUF .is-solution (qui reste ouverte)
        cards.forEach(function(c){
          if (c.classList.contains('is-solution')) return;
          c.dataset.open = 'false';
          var b = c.querySelector('.v3-morph-toggle');
          if (b) {
            b.setAttribute('aria-expanded', 'false');
            b.style.minHeight = '';
          }
        });
        // Open this if it wasn't already
        if (!wasOpen) {
          card.dataset.open = 'true';
          btn.setAttribute('aria-expanded', 'true');
          adjustMobileHeight(card);
          // Wait for close animation to settle, then scroll only if needed
          setTimeout(function(){
            var rect = card.getBoundingClientRect();
            var headerOffset = 130;
            var viewportH = window.innerHeight;
            // Scroll only if card top is above the header zone, or too low in viewport
            if (rect.top < headerOffset - 8 || rect.top > viewportH * 0.4) {
              window.scrollTo({
                top: window.pageYOffset + rect.top - headerOffset,
                behavior: 'smooth'
              });
            }
          }, 600);
        } else {
          // Close → reset mobile height inline style
          card.querySelector('.v3-morph-toggle').style.minHeight = '';
        }
      });
    });
  });

/* ===== block lines 1536-1609 ===== */
(function(){
  var root = document.querySelector('.fpb-root');
  if (!root) return;

  var mainImg = root.querySelector('.fpb-main img');
  var thumbs = root.querySelectorAll('.fpb-thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      var img = t.querySelector('img');
      if (!img || !mainImg) return;
      mainImg.src = img.getAttribute('src').replace(/([?&])(width|height)=\d+/g, '$1$2=1200');
      mainImg.alt = img.alt || '';
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var sub = root.querySelector('.fpb-sub');
  var variants = root.querySelectorAll('.fpb-variant');
  var cta = root.querySelector('.fpb-cta');
  var ctaOld = cta ? cta.querySelector('.fpb-cta-prices .old') : null;
  var ctaNew = cta ? cta.querySelector('.fpb-cta-prices .new') : null;

  function selectOption(el){
    var oneoff = root.querySelector('.fpb-oneoff');
    var isSub = (el === sub);
    if (sub) { sub.classList.toggle('is-active', isSub); sub.classList.toggle('is-inactive', !isSub); }
    if (oneoff) oneoff.classList.toggle('is-active', !isSub);
    variants.forEach(function(v){ v.classList.toggle('is-active', v === el); });
    var subRadio = sub ? sub.querySelector('.fpb-radio') : null;
    var oneoffRadio = root.querySelector('.fpb-oneoff-head .fpb-radio');
    if (subRadio) subRadio.classList.toggle('is-on', isSub);
    if (oneoffRadio) oneoffRadio.classList.toggle('is-on', !isSub);
    var price = el.getAttribute('data-price') || '';
    var old = el.getAttribute('data-old') || '';
    if (ctaOld){ ctaOld.textContent = old; ctaOld.style.display = old ? '' : 'none'; }
    if (ctaNew) ctaNew.textContent = price;
  }
  if (sub) sub.classList.add('is-active');
  if (sub) sub.addEventListener('click', function(){ selectOption(sub); });
  variants.forEach(function(v){ v.addEventListener('click', function(){ selectOption(v); }); });

  var oneoffHead = root.querySelector('.fpb-oneoff-head');
  if (oneoffHead && variants[0]) {
    oneoffHead.style.cursor = 'pointer';
    oneoffHead.addEventListener('click', function(){ selectOption(variants[0]); });
  }

  var rass = root.querySelector('.fpb-rass');
  if (rass) {
    var track = rass.querySelector('.fpb-rass-track');
    var items = rass.querySelectorAll('.fpb-rass-item');
    var dots = rass.querySelectorAll('.fpb-dot');
    var idx = 0;
    var n = items.length;
    var timer = null;

    function goTo(i){
      idx = (i + n) % n;
      if (track) track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function(d, di){ d.classList.toggle('is-on', di === idx); });
    }
    function next(){ goTo(idx + 1); }
    function start(){ stop(); timer = setInterval(next, 3500); }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function(d, di){
      d.addEventListener('click', function(){ goTo(di); start(); });
    });
    rass.addEventListener('mouseenter', stop);
    rass.addEventListener('mouseleave', start);
    start();
  }
})();


}
